import { render } from "./App.vue?vue&type=template&id=ed72c6e4&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./App.scss?vue&type=custom&index=0&blockType=link&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2FApp.vue&rel=stylesheet&lang=scss&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__